/** @prettier */

/**
 * ロゴ関連関数一覧
 */

import {Storage} from 'aws-amplify';

import {file} from '../define';

/**
 * ロゴ取得
 * @param maccessLogoCallback M-ACCESS用のロゴ画像コールバック関数
 * @param mhiLogoCallback MHI用のロゴ画像コールバック関数
 */
const getLogo = async (
  maccessLogoCallback: (response: string) => void,
  mhiLogoCallback: (response: string) => void
) => {
  Storage.configure({customPrefix: {private: file.LOGO_S3_KEY_PREFIX}});

  //M-ACCESSとMHIのロゴ画像の有無を検索
  /** M-ACCESSのロゴ画像の有無 */
  let hasMaccessLogo = false;
  /** MHIのロゴ画像の有無 */
  let hasMHILogo = false;
  try {
    const logoList = await Storage.list('', {
      level: 'private',
      pageSize: 1000, //ワーニング除去の為。運用的に対象のバケットに1000個より多いオブジェクトは保存しない想定
    });

    logoList.results.forEach(imageData => {
      if (imageData.key === file.MACCESS_LOGO_NAME) {
        hasMaccessLogo = true;
      } else if (imageData.key === file.MHI_LOGO_NAME) {
        hasMHILogo = true;
      }
    });
  } catch (error) {
    maccessLogoCallback(file.MACCESS_LOGO_PATH); //初期画像
    mhiLogoCallback(file.MHI_LOGO_PATH); //初期画像
  }

  //M-ACCESS用のロゴ画像がある場合、S3内の画像を取得
  try {
    if (hasMaccessLogo) {
      /** M-ACCESS用のロゴ画像 */
      const logo = await Storage.get(file.MACCESS_LOGO_NAME, {
        level: 'private',
      });
      maccessLogoCallback(logo);
    } else {
      maccessLogoCallback(file.MACCESS_LOGO_PATH); //初期画像
    }
  } catch (error) {
    maccessLogoCallback(file.MACCESS_LOGO_PATH); //初期画像
  }

  //MHI用のロゴ画像がある場合、S3内の画像を取得
  try {
    if (hasMHILogo) {
      /** MHI用のロゴ画像 */
      const logo = await Storage.get(file.MHI_LOGO_NAME, {level: 'private'});
      mhiLogoCallback(logo);
    } else {
      mhiLogoCallback(file.MHI_LOGO_PATH); //初期画像
    }
  } catch (error) {
    mhiLogoCallback(file.MHI_LOGO_PATH); //初期画像
  }
};

export default getLogo;
